import {
  type XmaxErrorFallback,
  XmaxSdkError,
  toXmaxSdkError,
  attachPublicErrorDetails,
  getErrorDiagnostics,
} from './sdk-error'

/** SDK error callback. The first message argument preserves existing integrations. */
export type XmaxErrorNotifier = (message: string, error: XmaxSdkError) => void

const notifiedErrors = new WeakSet<XmaxSdkError>()

export function isNotifiedError(error: unknown): error is XmaxSdkError {
  return error instanceof XmaxSdkError && notifiedErrors.has(error)
}

export function notifyError(
  error: unknown,
  notifier: XmaxErrorNotifier | undefined,
  fallback: string | XmaxErrorFallback,
): XmaxSdkError {
  const resolved = toXmaxSdkError(error, typeof fallback === 'string'
      ? {
        code: 'UNKNOWN_ERROR',
        message: fallback,
      }
    : fallback)

  attachPublicErrorDetails(resolved, getErrorDiagnostics(error) ?? {})
  if (!notifiedErrors.has(resolved) && notifier) {
    notifiedErrors.add(resolved)
    try {
      notifier(resolved.message, resolved)
    } catch {
      // Consumer error handlers must not replace the SDK error or interrupt cleanup.
    }
  }

  return resolved
}
